import { createSelector } from 'reselect'

export const getPointsData = (state) => state.mars.pointsManager

export const getValues = getPointsData
